import { Classification } from '@yes.technology/react-toolkit'
import { createContext, useContext } from 'react'
import { AssociatedUsersRelationsProps } from '../../Kanban.types'

type KanbanContextValue = {
  onStatusChange: (taskUuid: string, newStatusColumn: string) => void
  statusActionClassification?: Classification[]
  associatedUsersRelations: AssociatedUsersRelationsProps
}

const defaultValue = {
  onStatusChange: () => undefined,
  statusActionClassification: Array<Classification>(),
  associatedUsersRelations: []
}

export const KanbanContext = createContext<KanbanContextValue>(defaultValue)

export default function useKanbanContext() {
  const contextValue = useContext(KanbanContext)

  return contextValue
}
